export default "__VITE_ASSET__qt$MbTkv__"